export default __webpack_public_path__ + "static/media/personalaccident.9a7a3405.svg";